import { render } from "./bite-card.vue?vue&type=template&id=96782878"
import script from "./bite-card.vue?vue&type=script&lang=js"
export * from "./bite-card.vue?vue&type=script&lang=js"

import "./bite-card.vue?vue&type=style&index=0&id=96782878&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__